import React from 'react';

import './CountdownTimer.component.css';

export default class CountdownTimer extends React.Component {
    state = {
        timeRemaining: 2 * 3600
    };

    constructor(props) {
        super(props);

        {
            const currentTime = new Date().getTime();
            const TWO_HOURS_IN_MILLISECONDS = 2 * 3600 * 1000;
            //const TWO_HOURS_IN_MILLISECONDS = 18000; //testing 30 seconds

            this.state.endCountdownTime = new Date(currentTime + TWO_HOURS_IN_MILLISECONDS);
        }

        this.startTimeInterval();

        this.renderHours = this.renderHours.bind(this);
        this.renderMinutes = this.renderMinutes.bind(this);
        this.renderSeconds = this.renderSeconds.bind(this);
    }

    startTimeInterval() {
        const interval = setInterval(() => {
            const currentTime = new Date().getTime();
            const timeRemaining = this.state.endCountdownTime.getTime() - currentTime;

            const secondsRemaining = Math.floor(timeRemaining / 1000);

            this.setState({
                timeRemaining: Math.max(secondsRemaining, 0)
            });

            if (secondsRemaining <= 0) {
                clearInterval(interval);
                this.props.onCountdownExpired();
            }
        }, 100);
    }

    renderHours() {
        const hours = Math.floor(this.state.timeRemaining / 3600);
        return (
            <span>{ hours.toString().padStart(2, '0') }</span>
        )
    }

    renderMinutes() {
        const minutes = Math.floor(this.state.timeRemaining / 60) % 60;
        return (
            <span>{ minutes.toString().padStart(2, '0') }</span>
        )
    }

    renderSeconds() {
        const seconds = this.state.timeRemaining % 60;
        return (
            <span>{ seconds.toString().padStart(2, '0') }</span>
        )
    }

    getTimeWarningClass() {
        if (this.state.timeRemaining < 600) { // 10 minutes
            return 'low-time-warning';
        }
        
        return '';
    }

    render() {
        return (
            <span className={this.getTimeWarningClass()}>
                { this.renderHours() }:
                { this.renderMinutes() }:
                { this.renderSeconds() }
            </span>
        );
    }
}
